import React from 'react'
import type { PromptLock } from '../api/client'
import { Icon } from '../ui/Icon'
import RungSheet from './RungSheet'
import { UNLOCK_WITH_PRO } from './rungs'
import './billing.css'

interface Props {
  // hint is what Pro adds here, the pill's second line.
  hint: string
  lock: PromptLock
  children: React.ReactNode
  className?: string
}

// ProLock is a Pro area shown locked (owner, 2026-10-24): the area itself,
// faded and out of reach, under one centred pill with a lock, "Unlock with
// Pro" and a hint. The whole area is one button, which opens the Pro sheet.
// The faded content is hidden from assistive tech and made inert (React 18
// has no inert prop, so it is set on the node), so nothing in it is focusable.
export default function ProLock({ hint, lock, children, className = '' }: Props) {
  const [open, setOpen] = React.useState(false)
  const content = React.useRef<HTMLDivElement>(null)
  React.useLayoutEffect(() => {
    content.current?.setAttribute('inert', '')
  }, [])
  return (
    <div className={`pro-lock ${className}`.trim()}>
      <div ref={content} className="pro-lock__content" aria-hidden="true">
        {children}
      </div>
      <button
        type="button"
        className="pro-lock__cover"
        aria-label={`${UNLOCK_WITH_PRO}: ${hint}`}
        aria-haspopup="dialog"
        onClick={() => setOpen(true)}
      >
        <span className="pro-lock__pill">
          <Icon name="lock" size={22} />
          <span className="pro-lock__text">
            <span className="pro-lock__title">{UNLOCK_WITH_PRO}</span>
            <span className="pro-lock__hint">{hint}</span>
          </span>
        </span>
      </button>
      {/* The sheet opens on what she tapped (review, 2026-10-25). */}
      {open && <RungSheet rung="pro" lock={lock} context={hint} onClose={() => setOpen(false)} />}
    </div>
  )
}
